// Dependencies
//import axios from 'axios';
import 'whatwg-fetch';
import queryString from 'query-string';

// Utils
import HttpError from './httpError';
import { logToConsole } from './log';


export const HEADERS = Object.freeze({
  CONTENT_TYPE: {
    APP_JSON: 'application/json',
    APP_X_WWW_FORM_URLENCODED: 'application/x-www-form-urlencoded'
    // APP_OCTET_STREAM: 'application/octet-stream',
    // APP_VND_GOOGLE_EARTH_KML: 'application/vnd.google-earth.kml'
  },
  ACCEPT: {
    APP_JSON: 'application/json',
    APP_OCTET_STREAM: 'application/octet-stream'
  }
});

export function apiEndpoint(endpoint, qs, fetchingFrom) {
  let query = '';
  let apiUrl = process.env.REACT_APP_API_URL;

  if (qs) {
    query = `?${qs}`;
  }

  if (fetchingFrom === 'server') {
    apiUrl = 'http://localhost:3000';
  }

  return `${apiUrl}/${endpoint}${query}`;
}

export function apiFetch(endpoint, options = {}, query = false) {
  let qs;
  const { fetchingFrom = 'client' } = options;

  delete options.fetchingFrom;

  if (query) {
    qs = queryString.stringify(query);
  }

  const fetchOptions = apiOptions(options);
  const fetchEndpoint = apiEndpoint(endpoint, qs, fetchingFrom);

  logToConsole('Endpoint: ', fetchEndpoint, 'Options: ', fetchOptions);

  return fetch(fetchEndpoint, fetchOptions)
    .then(response => {
      const { status, ok, statusText } = response;

      logToConsole('Response: ', response);
      if (ok && status >= 200 && status < 300) {
        return response;
      }

      return Promise.reject(new HttpError(
        status,
        statusText || 'Something was wrong.'
      ));
    })
    .then(response => {
      const contentType = fetchOptions.headers['Content-Type'];
      const accept = fetchOptions.headers.Accept;

      // Object.keys(fetchOptions.headers).forEach(h => {
      //   logToConsole(`${h}: `, fetchOptions.headers[h]);
      // });

      if (contentType === HEADERS.CONTENT_TYPE.APP_X_WWW_FORM_URLENCODED) {
        return response.text()
          .then(result => new Promise((resolve, reject) => {
            try {
              //Ex. url: "http://rwaves-dev.ripplenami.com/web/;jsessionid=1axdjlg1y12js7gyk96bzy49t"
              const token = response.url.split('jsessionid=')[1];
              resolve({ token });
            } catch (error) {
              reject(error);
            }
          }));
      }

      switch (accept) {
        case HEADERS.ACCEPT.APP_OCTET_STREAM:
          return response.text();

        case HEADERS.ACCEPT.APP_JSON:
        default:
          return response.json()
            .then(result => new Promise((resolve, reject) => {
              const { success = true, code, message } = result;
              if (success) {
                resolve(result);
              } else {
                reject(new HttpError(code, message));
              }
            }));
      }
    });
}

export function apiOptions(options = {}) {
  const {
    method = 'GET',
    headers = {
      'Content-Type': HEADERS.CONTENT_TYPE.APP_JSON
    },
    body = false
  } = options;

  const newOptions = {
    method,
    headers //, credentials: 'include'
  };

  if (!Object.keys(headers).some(h => h === 'Accept')) {
    newOptions.headers = {
      ...newOptions.headers,
      'Accept': HEADERS.ACCEPT.APP_JSON
    };
  }

  if (body) {
    const contentType = newOptions.headers['Content-Type'];

    if (!contentType) {
      newOptions.headers = {
        ...newOptions.headers,
        'Content-Type': HEADERS.CONTENT_TYPE.APP_JSON
      };
    }

    // For login endpoint
    newOptions.body = contentType === HEADERS.CONTENT_TYPE.APP_X_WWW_FORM_URLENCODED
      ? formBody(body)
      : JSON.stringify(body);
  }

  return newOptions;
}

function formBody(body) {
  const formBody = [];
  for (const property in body) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(body[property]);
    formBody.push(`${encodedKey}=${encodedValue}`);
  }
  return formBody.join('&');
}
